import React from 'react';
import { UserPersona } from '../OnboardingWizard';

interface PersonaSelectionProps {
  onSelect: (persona: UserPersona) => void;
}

const PERSONAS = [
  {
    id: 'fisherman',
    title: 'Pescador',
    icon: 'phishing',
    desc: 'Quero descobrir pesqueiros, registrar capturas e eventos.',
    gradient: 'from-[#029DE1] to-[#046993]'
  },
  {
    id: 'business',
    title: 'Tenho um Negócio',
    icon: 'storefront',
    desc: 'Tenho uma Pousada, Barco-Hotel ou Loja e busco clientes.',
    gradient: 'from-[#EC5002] to-[#C03500]'
  },
  {
    id: 'influencer',
    title: 'Criador de Conteúdo',
    icon: 'photo_camera',
    desc: 'Produzo conteúdo de pesca e quero ampliar minha audiência.',
    gradient: 'from-[#8B5CF6] to-[#6D28D9]'
  }
] as const;

export const PersonaSelection: React.FC<PersonaSelectionProps> = ({ onSelect }) => {
  return (
    <div className="w-full flex flex-col items-center animate-fade-in-up">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-display font-bold mb-2">Quem é você na Pesca?</h2>
        <p className="text-white/60 text-sm">Escolha o perfil que melhor te descreve.</p>
      </div>

      <div className="w-full space-y-4">
        {PERSONAS.map((p) => (
          <button
            key={p.id}
            onClick={() => onSelect(p.id as UserPersona)}
            className="w-full relative group overflow-hidden rounded-2xl border border-white/10 p-1 text-left transition-all duration-300 hover:scale-[1.02] active:scale-95"
          >
            {/* Card Background with customized gradient */}
            <div className={`absolute inset-0 bg-gradient-to-br ${p.gradient} opacity-10 group-hover:opacity-20 transition-opacity`} />
            
            <div className="relative z-10 bg-[#0F172A]/80 backdrop-blur-md rounded-xl p-5 flex items-start gap-4 h-full border border-white/5">
               <div className={`w-12 h-12 rounded-full bg-gradient-to-br ${p.gradient} flex items-center justify-center shadow-lg`}>
                 <span className="material-symbols-outlined text-white text-2xl">{p.icon}</span>
               </div>
               
               <div className="flex-1">
                 <h3 className="font-bold text-lg text-white mb-1 group-hover:text-glow transition-all">{p.title}</h3>
                 <p className="text-xs text-white/50 leading-relaxed font-light">{p.desc}</p>
               </div>

               <div className="self-center opacity-0 group-hover:opacity-100 transition-opacity -translate-x-2 group-hover:translate-x-0 transform duration-300">
                 <span className="material-symbols-outlined text-white/70">chevron_right</span>
               </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};
